import React from "react";
import { Helmet } from "react-helmet";
import { Col,Container, Row } from "reactstrap";
import { create } from "apisauce";
import { API_URL } from "libs/config";
import styled from "styled-components";

const api = create({ baseURL: API_URL });

export function createStaticPropsGetter(path: string) {
  return async () => {
    const page = await api.get(`/api/pages/${path}/`);
    if (!page.ok) throw new Error("Impossible de récupérer le contenu");
    return {
      props: {
        page: page.data,
      },
    };
  };
}

export interface Page {
  id: number;
  title: string;
  content: string;
  templateName: string;
}

type PageProps = {
  page: Page;
};

const Wrapper = styled(Container)`
  h1 {
    font-size: 1.8rem;
    color: #036b7c;
    text-transform: uppercase;
    font-weight: 700;
  }
  h2 {
    color: #036b7c;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 2rem;
  }
  h3 {
    color: #000;
    font-size: 1.75rem;
    text-transform: uppercase;
    font-weight: 700;
  }
  .block h3 {
    font-size: 1rem;
  }
  h2 {
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
  p.lead {
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    color: #348b9d;
  }
  .col-lg-6 p {
    color: #348b9d;
    font-weight: 500;
  }
  .col-lg-8 p {
  color: #348b9d;
  font-weight: 500;
  }
  li {
    color: #348b9d;
  }
  a {
    color: #036b7c;
  }
  hr {
    border-color: #036b7c;
    margin: 16px 8%;
    border-top: px solid rgba(0,0,0,.1);
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }
  span.text-uppercase {
    color: #000;
    font-weight: 700;
  }
  span.text-highlight {
    color: #000;
    font-weight: 700;
  }
  .block.blue.bordered.row {
    padding: 1rem .5rem;
    text-align: center;
    vertical-align: top;
    margin: 2rem 0;
    border: 2px solid #348b9d;
    display: flex;
    flex-wrap: wrap;
  }
  .col-lg-6:first-of-type:after {
    content: " ";
    display: block;
    background-color: #348b9d;
    width: 2px;
    height: 90%;
    position: absolute;
    right: 0;
    top: 5%;
`;
export function Page({ page }: PageProps) {
  return (
    <>
      <Helmet>
        <title>{page.title}</title>
      </Helmet>
      <Wrapper>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div dangerouslySetInnerHTML={{ __html: page.content }} />
          </Col>
        </Row>
      </Wrapper>
    </>
  );
}
